import { render, staticRenderFns } from "./EmailTemplateNew.vue?vue&type=template&id=7104b012&scoped=true&"
import script from "./EmailTemplateNew.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateNew.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateNew.vue?vue&type=style&index=0&id=7104b012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7104b012",
  null
  
)

export default component.exports